import React from 'react';
import PropTypes from 'prop-types';
import Loading from '../../Components/Loading';
import EmptyVisualization from '../../Components/EmptyVisualization';
import DataGrid from '../../Components/DataGrid';

const TableWrapper = ({ data, defaultPageSize }) => (
  <DataGrid
    data={data}
    columns={[
      {
        Header: 'Source',
        accessor: 'source',
        maxWidth: 100,
      },
      {
        Header: 'Threats',
        columns: [
          {
            Header: 'Total',
            accessor: 'threats.count',
            maxWidth: 55,
          },
          {
            Header: 'P1',
            accessor: 'threats.p1',
            maxWidth: 55,
          },
          {
            Header: 'P2',
            accessor: 'threats.p2',
            maxWidth: 55,
          },
          {
            Header: 'P3',
            accessor: 'threats.p3',
            maxWidth: 55,
          },
        ],
      },
      {
        Header: 'Suspects',
        columns: [
          {
            Header: 'Total',
            accessor: 'suspects.count',
            maxWidth: 55,
          },
          {
            Header: 'P1',
            accessor: 'suspects.p1',
            maxWidth: 55,
          },
          {
            Header: 'P2',
            accessor: 'suspects.p2',
            maxWidth: 55,
          },
          {
            Header: 'P3',
            accessor: 'suspects.p3',
            maxWidth: 55,
          },
        ],
      },
    ]}
    showPagination={false}
    showPageSizeOptions={false}
    showPageJump={false}
    resizeable={false}
    defaultPageSize={defaultPageSize}
    compactStyle
    sorted={[{
      id: 'threats.count',
      desc: true,
    }]}
  />
);

TableWrapper.propTypes = {
  data: PropTypes.instanceOf(Array).isRequired,
  defaultPageSize: PropTypes.number.isRequired,
};

const LocationsData = ({ tableData, defaultPageSize, handleRetry }) => {
  const tableIsLoading = tableData.loading || !tableData.firstLoadComplete;
  const tableIsEmpty = !tableData.loading && tableData.dataIsEmpty;
  const tableHasError = !!tableData.error;

  return (
    <React.Fragment>
      { tableIsLoading &&
        <Loading />
      }

      { (tableIsEmpty || tableHasError) &&
        <div>
          <EmptyVisualization
            isError={tableHasError}
            handleRetry={handleRetry}
          >
            <TableWrapper
              data={tableData.visualizationData}
              defaultPageSize={defaultPageSize}
            />
          </EmptyVisualization>
        </div>
      }

      { !tableIsLoading && !tableIsEmpty && !tableHasError &&
        <TableWrapper
          data={tableData.visualizationData}
          defaultPageSize={defaultPageSize}
        />
      }
    </React.Fragment>
  );
};

LocationsData.propTypes = {
  tableData: PropTypes.shape({}).isRequired,
  defaultPageSize: PropTypes.number,
  handleRetry: PropTypes.func.isRequired,
};
LocationsData.defaultProps = {
  defaultPageSize: 10,
};

export default React.memo(LocationsData);



// WEBPACK FOOTER //
// ./src/views/Pages/Dashboard/LocationsTable.js